import React from 'react'

function Checkbox({
  selected,
  disabled,
  onChange
}) {
  return (
    <div className="bg-white dark:bg-gray-800 border rounded-sm border-gray-400 dark:border-gray-700 w-4 h-4 flex flex-shrink-0 justify-center items-center relative">
        <input disabled={disabled} checked={selected} onChange={onChange} type="checkbox" className={`checkbox opacity-0 absolute ${disabled ? "" : "cursor-pointer"} w-full h-full`} />
        <div className="check-icon hidden bg-primary text-white rounded-sm">
            <svg className="icon icon-tabler icon-tabler-check" xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" />
                <path d="M5 12l5 5l10 -10" />
            </svg>
        </div>
        <style>
          {`.checkbox:checked {
              border: none;
          }
          .checkbox:checked + .check-icon {
              display: flex;
          }`}
        </style>
    </div>
  )
}

export default Checkbox
